const uk = {
    "sc_title": "Центр безпеки",
    "sc_subtitle": "Інтегрований рівень безпеки GaiaShield",
    "sc_tab_status": "🛡️ Статус захисту",
    "sc_tab_events": "📋 Журнал безпеки",
    "sc_tab_node": "⚙️ Безпека вузла",
    "sc_loading": "Завантаження даних безпеки...",
    "sc_status_secured": "Статус системи: Обліковий запис захищено",
    "sc_status_warning": "Статус системи: Активні попередження",
    "sc_desc_secured": "Немає активних критичних попереджень. GaiaShield активно моніторить ваш обліковий запис.",
    "sc_desc_warning": "Увага: Є активні події безпеки, які потребують вашої уваги.",
    "sc_account_protection": "Захист облікового запису",
    "sc_message_protection": "Захист повідомлень",
    "sc_audits": "Аудит безпеки",
    "sc_active": "АКТИВНО",
    "sc_failed_logins": "Невдалі входи",
    "sc_tamper_checks": "Перевірки втручання",
    "sc_blocked_replays": "Заблоковані повтори",
    "sc_last_check": "Остання перевірка",
    "sc_just_now": "Щойно",
    "sc_open_warnings": "Відкриті попередження",
    "sc_btn_acknowledge": "Підтвердити",
    "sc_filter_severity": "Важливість",
    "sc_filter_category": "Категорія",
    "sc_filter_hide_ack": "Приховати підтверджені",
    "sc_btn_export": "Експорт",
    "sc_col_details": "Деталі",
    "sc_col_time": "Час",
    "sc_col_status": "Статус",
    "sc_col_action": "Дія",
    "sc_no_events": "Подій безпеки не знайдено.",
    "sc_node_title": "Консоль безпеки оператора вузла",
    "sc_system_health": "Стан системи",
    "sc_last_audit": "Останній аудит",
    "sc_packed_logs": "Архівовані журнали",
    "sc_unconfirmed_events": "Непідтверджені події",
    "sc_operator_action": "Потрібна дія оператора",
    "sc_all_ok": "Все в порядку",
    "sc_critical_events": "Критичні події системи",
    "ac_title": "Центр управління та скарг",
    "ac_subtitle": "Консенсус управління та скарг GaiaCom",
    "ac_tab_my_reports": "Мої скарги",
    "ac_tab_queue": "Черга перевірок",
    "ac_tab_operator": "Оператор вузла",
    "ac_tab_transparency": "Федерація та прозорість",
    "ac_loading": "Завантаження даних...",
    "ac_reported_cases": "Повідомлені випадки",
    "ac_no_reports": "Ви ще не надсилали скарг.",
    "ac_case_details": "Деталі справи",
    "ac_appeal_submit": "Подати апеляцію",
    "ac_appeal_status": "Статус апеляції",
    "ac_appeal_reason": "Причина апеляції",
    "ac_appeal_statement": "Заява",
    "ac_btn_appeal": "Надіслати апеляцію",
    "ac_trusted_reviewer_queue": "Черга довірених рецензентів",
    "ac_case_review": "Розглянути справу",
    "ac_review_category": "Рекомендована категорія",
    "ac_review_severity": "Рекомендована важливість",
    "ac_review_action": "Рекомендована дія",
    "ac_review_reason": "Обґрунтування рецензента",
    "ac_btn_submit_review": "Надіслати перевірку",
    "ac_node_operator_dashboard": "Панель оператора вузла",
    "ac_apply_action": "Застосувати дію (Перевизначення)",
    "ac_target_type": "Тип цілі",
    "ac_target_id": "ID цілі (GaiaID або ID каналу)",
    "ac_suspend": "Призупинення активне",
    "ac_reason": "Офіційна причина",
    "ac_btn_apply": "Застосувати захід",
    "ac_transparency_title": "Журнал консенсусу та прозорості",
    "ac_transparency_desc": "Загальнодоступні докази моментальних знімків усіх модерованих каналів та ідентичностей.",
    "ac_btn_snapshot": "Створити моментальний знімок прозорості",
    "search_placeholder": "Пошук листів за темою, відправником, текстом...",
    "abuse_center_title": "Центр скарг",
    "abbrechen": "Скасувати",
    "active_identities": "Активні ідентичності",
    "active_identity": "Активна ідентичність",
    "add_btn": "додати",
    "add_contact_title": "Додати контакт",
    "admin": "адмін",
    "adressbuch": "каталог",
    "aktiviert": "Увімкнено",
    "an": "до",
    "anonymous_sender": "Анонімний відправник",
    "antworten": "Відповідь",
    "attachment_gaia_hint": "Вкладення GaiaCOM залишаються в наскрізному шифруванні.",
    "attachment_smtp_hint": "Застарілий SMTP блокує виконувані файли/вкладення, схожі на сценарії, і зберігає електронні листи як незахищені.",
    "attachments": "Додатки",
    "auffaellig": "Помітно",
    "auth_beta_notice": "Стадія бета-тестування: GaiaCOM активно тестується. Можуть виникати помилки; захистити важливі вихідні дані та ретельно перевірити конфіденційні робочі процеси.",
    "auth_btn_login": "Завантажте ідентифікатор і увійдіть",
    "auth_btn_register": "Зареєструйтеся та створіть криптовалюту",
    "auth_copied": "Скопійовано",
    "auth_copy_seed": "Копіювати насіння",
    "auth_generate_seed": "Генерувати насіння",
    "auth_headline": "GaiaCOM — це перший квантово безпечний протокол електронної пошти та система зв’язку, створена для людства.",
    "auth_kicker": "Постквантовий безпечний зв'язок",
    "auth_mnemonic": "Мнемонічна фраза",
    "auth_mnemonic_placeholder": "12 слів, розділених пробілами...",
    "auth_password": "пароль",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Приватні ключі не залишають ваш пристрій. Лише цільові одержувачі можуть розшифрувати вміст.",
    "auth_proof_gaiadata_desc": "Нульовий рівень знань: Ви продовжуєте контролювати свої дані. Метадані зведені до мінімуму та не використовуються як простий текстовий профіль.",
    "auth_proof_gaiadrop_desc": "Зовнішні люди можуть надсилати конфіденційні текстові повідомлення на ваш GaiaID без облікового запису.",
    "auth_proof_gaiaproof_desc": "Докази доставки та цілісності показують, що зашифрований текст, відправник і позначка часу не були підроблені.",
    "auth_proof_gaiavault_desc": "Особисті нотатки, нотатки щодо відновлення та записи безпеки залишаються локально зашифрованими.",
    "auth_proof_hybrid_desc": "Quantum Shield: гібридне шифрування з ML-KEM і X25519 захищає від сучасних атак і ризиків зберігання, розшифрування й пізніше.",
    "auth_secure_mail": "Безпечна Quantum Federated Mail",
    "auth_subline": "GaiaCOM — це квантова захищена комунікаційна система для електронної пошти, чату, кризових кімнат, GaiaDrop і локальних файлів безпеки. Приватні ключі залишаються на вашому пристрої, вміст наскрізно шифрується, а докази можна експортувати без звичайного тексту.",
    "auth_success_btn": "Увійдіть зараз",
    "auth_success_text": "Ваш обліковий запис GaiaCOM створено. Ключі були отримані локально з вашого початкового коду і не зберігалися на сервері.",
    "auth_success_title": "Реєстрація успішна",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Логін/Обліковий запис",
    "auth_toggle_login": "Обліковий запис уже існує",
    "auth_toggle_register": "Створити новий акаунт",
    "auth_usecase_text": "Підходить для юристів, компаній, органів влади, журналістів, інформаторів і приватних охоронців.",
    "auth_usecase_title": "Створено для чутливого спілкування",
    "auth_username": "ім'я користувача",
    "auth_username_placeholder": "Введіть ім'я...",
    "auth_value_chat": "Чат E2E",
    "auth_value_drop": "Безпечне падіння",
    "auth_value_mail": "Безпечна пошта",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Підтвердити",
    "bestaetigt": "Підтверджено",
    "bio_status": "Біографія/Статус",
    "biography": "біографія",
    "change_password_desc": "Змінює ваш пароль для входу на стороні сервера. Ваша локальна фраза відновлення залишається окремо захищеною вашим паролем сховища/розблокування.",
    "change_password_menu_desc": "Оновіть пароль для входу в GaiaCOM.",
    "change_password_title": "Змінити пароль",
    "channel_id": "ID каналу",
    "channel_name_label": "Назва каналу",
    "chat_deleted_hidden": "Чат видалено та приховано.",
    "chat_input_placeholder": "Введіть безпечне повідомлення...",
    "chat_start_hint": "Почніть розмову! Усі повідомлення чату шифруються квантово безпечно E2E.",
    "choose_avatar": "Виберіть аватар",
    "ciphertext_hash": "Хеш зашифрованого тексту",
    "clear_chat": "Порожній чат",
    "clear_for_everyone": "Пусто для всіх",
    "clear_for_me": "Порожній лише для мене",
    "click_to_write_mail": "Натисніть, щоб написати електронний лист",
    "click_top_right": "Натисніть у верхньому правому куті",
    "close": "Закрити",
    "code_kopieren": "Скопіюйте код",
    "code_kopieren_success": "Код скопійовано",
    "confirm_clear_channel_desc": "Ви хочете очистити цей канал від локального перегляду?",
    "confirm_clear_channel_title": "Порожній канал",
    "confirm_clear_chat": "Ви хочете очистити цей чат?",
    "confirm_clear_chat_desc": "Ви хочете очистити цей чат?",
    "confirm_clear_chat_title": "Порожній чат",
    "confirm_clear_everyone": "Ви хочете очистити чат для обох партнерів? (OK = Для всіх, Скасувати = Тільки для мене)",
    "confirm_delete_everyone": "Ви бажаєте видалити повідомлення для обох партнерів? (OK = Для всіх, Скасувати = Тільки для мене)",
    "confirm_delete_msg": "Ви бажаєте видалити це повідомлення?",
    "confirm_delete_msg_desc": "Ви бажаєте видалити це повідомлення чату?",
    "confirm_delete_msg_title": "Видалити повідомлення",
    "confirm_new_password": "Підтвердьте новий пароль",
    "copy": "Копія",
    "create_btn": "Створити",
    "create_channel_title": "Створити канал",
    "create_group_is_crisis": "Позначити як кризову зону",
    "create_group_title": "Створити нову групу",
    "crypto_lock_desc": "Контролює, коли GaiaCOM видаляє локальні криптографічні ключі з пам’яті.",
    "crypto_lock_menu_desc": "Керуйте таймерами перезавантаження та неактивності.",
    "crypto_lock_title": "Криптографічний замок",
    "crypto_session_duration": "Розблоковано після перезавантаження",
    "crypto_session_duration_desc": "Тримає крипто-сеанс відкритим лише на цій вкладці браузера протягом вибраного періоду.",
    "cryptographic_fingerprint": "Криптографічний відбиток",
    "current_password": "Поточний пароль",
    "data_minimization": "Мінімізація даних",
    "decrypt_failed": "Не розшифровується",
    "delete": "Видалити",
    "delete_account_button": "Безповоротно видалити обліковий запис",
    "delete_account_confirm_label": "Введіть DELETE для підтвердження",
    "delete_account_confirmation_error": "Необхідні пароль і підтвердження DELETE.",
    "delete_account_desc": "Цей режим назавжди знищує ваш обліковий запис, ідентифікаційні дані, сеанси пристрою, дані GaiaDrop, метадані завантаження та пов’язані з сервером повідомлення.",
    "delete_account_done_desc": "Усі дані GaiaCOM, які можна призначити, видалено.",
    "delete_account_done_title": "Обліковий запис видалено",
    "delete_account_menu_desc": "Знищити обліковий запис і пов’язані з ним дані.",
    "delete_account_not_authenticated": "Немає активного облікового запису.",
    "delete_account_title": "Видалити акаунт",
    "delete_for_everyone": "Видалити для всіх",
    "delete_for_me": "Видалити тільки для мене",
    "device_current": "Цей пристрій",
    "device_last_seen": "Останній",
    "device_logout": "Вийти",
    "device_sessions_desc": "Перевірте активні сесії та скасуйте реєстрацію пристроїв, яким більше не довіряєте.",
    "device_sessions_empty": "Пристроїв не знайдено.",
    "device_sessions_menu_desc": "Керуйте та завершуйте активні сеанси.",
    "device_sessions_title": "Зареєстровані пристрої",
    "device_since": "Оскільки",
    "display_name": "Відображуване ім'я",
    "drop_address_copied": "Адресу GaiaDrop скопійовано.",
    "drop_btn_decrypting": "Вхідні розшифровуються...",
    "drop_btn_load": "Завантажте папку \\",
    "drop_delete_desc": "Ви справді бажаєте остаточно видалити цю крапку?",
    "drop_delete_title": "Видалити GaiaDrop",
    "drop_desc": "Лише текстовий канал із нульовим знанням для зовнішніх повідомлень, відповідального розкриття та конфіденційних звітів. Зовнішні сторони можуть надсилати повідомлення без облікового запису за допомогою вашого GaiaID.",
    "drop_empty": "Ще не завантажено жодного повідомлення GaiaDrop.",
    "drop_id": "ID падіння:",
    "drop_own_address": "Ваша адреса GaiaDrop",
    "drop_proof": "ЗАХИСТ ДО ПАДІННЯ",
    "drop_title": "GaiaDrop Secure Inbox",
    "dunkler_modus": "Темний режим",
    "e2e_chat_room_open": "Відкрийте чат E2E",
    "edit_profile": "Редагувати профіль",
    "edit_profile_desc": "Налаштуйте ім'я, біографію та аватар.",
    "einladungscode": "Код запрошення",
    "enter_fingerprint_chars_confirm": "Для підтвердження введіть потрібні символи відбитків пальців.",
    "envelope_hash": "Хеш конверта",
    "erasability": "Стираемість",
    "erfolg": "Успіх",
    "exclude_plaintext": "Експорт без звичайного тексту",
    "export_disclosure": "Експортний футляр безпеки",
    "export_package_desc": "Включайте звичайний текст, лише якщо таке розголошення є навмисним.",
    "export_package_title": "Експорт пакета безпеки",
    "fehler": "помилка",
    "gaiacom_reader": "Читач GaiaCOM",
    "gaiadrop_inbox_title": "Вхідні GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM мінімізує метадані, зберігає приватні ключі локально, наскрізно шифрує вміст і дозволяє повністю видалити обліковий запис.",
    "gdpr_home_title": "100% сумісність з GDPR",
    "gdpr_reason_delete": "Видалення облікового запису видаляє обліковий запис, особисті дані, локальні сеанси та дані, які можна призначити на стороні сервера.",
    "gdpr_reason_e2ee": "Приватний вміст залишається розшифрованим лише для призначених одержувачів.",
    "gdpr_reason_minimal": "Метадані використовуються лише для маршрутизації, доставки та облікових даних безпеки.",
    "gdpr_reason_zero_knowledge": "Приватні ключі та дані відновлення залишаються локально під контролем користувача.",
    "gesendet": "Надіслано",
    "gesperrt_verdaechtig": "Забанено/підозріло",
    "group_delete_desc": "Ви справді бажаєте остаточно видалити цю групу? Усі канали та повідомлення в цій групі буде видалено.",
    "group_delete_title": "Видалити групу",
    "group_description": "опис",
    "group_icon_label": "Значок/аватар групи",
    "group_name": "Назва групи",
    "group_settings_avatar": "Аватар",
    "group_settings_desc": "опис",
    "group_settings_is_crisis": "Позначити як кризову зону",
    "group_settings_name": "Назва групи",
    "group_settings_title": "Налаштування групи",
    "groups_empty_desc": "Створіть безпечний робочий простір для проектів, криз або командного спілкування.",
    "groups_empty_title": "Групових чатів ще немає",
    "gruppe_beitreten": "Приєднався до групи",
    "gruppe_erstellen": "+ Створити групу",
    "gruppe_verlassen": "Вийти з групи",
    "gruppen_chats": "Групові чати",
    "heller_modus": "Яскравий режим",
    "how_to_receive_drops": "Як отримати краплі?",
    "identitaets_assistent": "Помічник ідентифікації",
    "inactivity_lock_duration": "Блокувати, коли неактивний",
    "inactivity_lock_duration_desc": "Після цього періоду відсутності введення GaiaCOM буде автоматично заблоковано криптографічно.",
    "inactivity_lock_notice": "GaiaCOM криптографічно заблоковано через бездіяльність.",
    "include_plaintext": "Додайте звичайний текст",
    "invite_code_label": "Код запрошення",
    "join_group_title": "Приєднатися до групи",
    "kanaele": "Канали",
    "kanal_erstellen": "+ канал",
    "kein_chat_ausgewaehlt": "Чат не вибрано",
    "kein_kanal_ausgewaehlt": "Канал не вибрано",
    "keine_gruppe_ausgewaehlt": "Не вибрано жодної групи",
    "keine_mails": "Немає доступних електронних листів.",
    "key_change_warn_desc": "Відкритий ключ цього контакту змінено. Перевірте відбиток пальця, перш ніж довіряти йому.",
    "key_change_warn_title": "Криптографічне попередження",
    "key_change_warning_changed": "змінився. Це може бути ознакою нападу \\",
    "key_change_warning_msg": "Ключ ідентифікації для контакту",
    "key_transparency": "Ключова прозорість",
    "kopiert": "Скопійовано",
    "kryptographische_schluessel": "Криптографічні ключі",
    "kryptographische_schluessel_desc": "Показати закриті ключі та резервну початкову фразу.",
    "laden": "Завантажити...",
    "leeren": "Порожній",
    "loading": "Завантажити...",
    "local_key_vault": "Місцеве сховище ключів",
    "local_keys_label": "Локальні ключі",
    "lock_on_reload": "Завжди блокувати після перезавантаження",
    "logout": "Вийти",
    "mail_compose": "Напишіть електронний лист",
    "mein_profil": "Мій профіль",
    "melden": "звіт",
    "menu": "меню",
    "message": "Новини",
    "message_id": "ID повідомлення",
    "message_pin": "Pin",
    "message_pinned_title": "Закріплені повідомлення",
    "message_react": "Реагувати",
    "message_reply": "Відповідь",
    "message_replying_to": "Відповідь на",
    "message_save": "зберегти",
    "message_saved": "Збережено",
    "message_to_channel": "Повідомлення до",
    "message_unpin": "Розв'язати",
    "message_unsave": "Не економте",
    "mitglied": "Член",
    "mitglieder": "членів",
    "ml_kem": "МЛ-КЕМ",
    "neue_mail": "Нова електронна пошта",
    "never_auto_lock": "Ніколи автоматично",
    "new_fingerprint": "Новий відбиток пальця",
    "new_identity": "Нова ідентичність",
    "new_password": "Новий пароль",
    "no_description": "Без опису",
    "no_key_history": "Історія ключів не записана.",
    "no_specification": "Не вказано",
    "old_fingerprint": "Старий відбиток пальця",
    "open_privacy_imprint": "Відкрити вихідні дані та захист даних",
    "post_quantum_e2e": "Постквантовий E2E",
    "posteingang": "Вхідні",
    "powered_by": "На основі",
    "privacy_imprint_menu_desc": "Показати GDPR, захист даних і правове повідомлення.",
    "privacy_imprint_profile_desc": "GaiaCOM обробляє комунікаційний контент відповідно до принципів мінімізації даних, наскрізного шифрування та контролю локального ключа.",
    "privacy_imprint_title": "Захист даних і правове повідомлення",
    "profil": "профіль",
    "profile_details": "Деталі профілю",
    "profile_settings_hint": "Параметри профілю відображаються на правій панелі.",
    "profile_unlock_desc": "З міркувань безпеки ви повинні повторно ввести свій пароль, щоб переглянути свої приватні криптографічні ключі.",
    "proof_hash": "Доказовий хеш:",
    "public_drop_desc": "Secure Drop для зовнішньої текстової інформації без облікового запису GaiaCOM.",
    "public_drop_message": "Новини",
    "public_drop_message_placeholder": "Введіть конфіденційний текст...",
    "public_drop_send": "Надіслати GaiaDrop",
    "public_drop_sender": "Примітка відправника необов’язкова",
    "public_drop_sender_placeholder": "Ім'я, номер файлу або анонім",
    "public_drop_target": "Цільовий GaiaID",
    "quanten_chat": "Квантовий чат",
    "quantum_secure_exchange": "Квантовий безпечний обмін через...",
    "quantum_secure_net": "GaiaCOM Quantum Secure Network (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "Мережа GaiaCOM захищає вашу конфіденційність за допомогою багаторівневого гібридного протоколу шифрування, захищеного від атак з квантових комп’ютерів майбутнього.",
    "quantum_shield_l1_desc": "Використовує стандарт FIPS 203 для інкапсуляції симетричного спільного ключа. Запобігає пасивному запису та подальшому розшифруванню («Зберігати зараз, розшифрувати пізніше») квантовими комп’ютерами.",
    "quantum_shield_l1_title": "1. Постквантовий захист (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Класична надзвичайно швидка процедура обміну ключами Діффі-Хеллмана, яка служить додатковим рівнем безпеки в гібридній процедурі.",
    "quantum_shield_l2_title": "2. Криптографія еліптичної кривої (X25519)",
    "quantum_shield_l3_desc": "Кожне повідомлення та кожен конверт Федерації підписано криптографічно, щоб однозначно перевірити автентичність відправника.",
    "quantum_shield_l3_title": "3. Цифрові підписи (Ed25519)",
    "quantum_shield_l4_desc": "Шифрує вміст повідомлення симетрично та тісно прив’язує відправника, одержувача та метадані до автентифікованих додаткових даних (AAD), щоб запобігти атакам відтворення.",
    "quantum_shield_l4_title": "4. Аутентифікація AAD (AES-256-GCM)",
    "quantum_shield_status": "Статус Quantum Shield",
    "receive_drops_step1": "Поділіться своїм GaiID (наприклад, за допомогою кнопки копіювання вище) зовнішнім джерелам.",
    "receive_drops_step2": "Вони викликають сторінку входу вашого екземпляра GaiaCOM і переходять на вкладку",
    "receive_drops_step3": "і відправити зашифроване повідомлення на вашу адресу.",
    "receiver_gaia": "Приймач GaiaCOM",
    "receiver_smtp": "Одержувач SMTP",
    "records_stored": "Записи збережено",
    "refresh": "оновлення",
    "report_abuse_desc": "Ви бажаєте повідомити про це повідомлення та надіслати на сервер криптографічні докази порушення?",
    "report_abuse_title": "Повідомити про порушення",
    "reputation_status": "Статус репутації",
    "room_chat_start_hint": "Почніть розмову! Усі повідомлення в цьому груповому каналі децентралізовано квантово-безпечно зашифровані E2E.",
    "room_policy_audit": "Журнал аудиту та ротація ключів активні.",
    "room_policy_crisis": "Кризова кімната",
    "room_policy_e2ee": "Простір нульових знань. Квантовий безпечний E2EE.",
    "room_policy_title": "Правила кімнати",
    "room_policy_zero_knowledge": "політика",
    "room_security_note_desc": "Усі ключові зміни перевіряються через Key Transparency. Використовуйте GaiaVault для приватних журналів резервного копіювання.",
    "room_security_note_title": "Закріплена примітка безпеки",
    "save_profile": "Зберегти профіль",
    "schluessel_entsperrt": "🔑 Знову заблокуйте ключ",
    "search_gaia_label": "Знайдіть адресу Gaia",
    "security_warning_title": "Попередження безпеки",
    "select_channel_chat": "Щоб поспілкуватися, виберіть канал на лівій бічній панелі.",
    "select_contact_chat": "Виберіть контакт на лівій панелі, щоб розпочати квантово-безпечний чат E2E.",
    "select_mail_read": "Виберіть електронний лист зі списку, щоб прочитати його квантово безпечний вміст або створити нове повідомлення.",
    "senden": "Надіслати",
    "sender_signature": "Підпис відправника",
    "server_log": "Журнал сервера:",
    "server_received": "Сервер отримано",
    "session_lock": "Блокування сесії",
    "setup_address_keys": "Створіть адресу та набір ключів",
    "setup_profile": "Налаштувати в профілі",
    "smtp_inbox_title": "прийом SMTP",
    "smtp_legacy_badge": "Застарілий SMTP/небезпечний",
    "smtp_mode_option": "Застарілий міст SMTP",
    "smtp_security_warning": "Цей електронний лист було передано через класичний незашифрований протокол SMTP. Наскрізне шифрування не активне.",
    "smtp_security_warning_desc": "Це повідомлення виходить із кімнати безпеки GaiaCom. Доставка SMTP не надає вбудованої наскрізної гарантії GaiCom, гарантії TrustMesh і Godmode від шлюзу.",
    "spam_verdacht": "Спам/підозра",
    "spam_warning_desc": "Це повідомлення має підозрілу репутацію.",
    "spam_warning_title": "Попередження про спам",
    "speichern": "зберегти",
    "sperren": "Блокування",
    "standard_group_status": "Стандартний груповий чат (зашифрований E2EE)",
    "status": "статус",
    "subject": "Щодо",
    "suchen": "Знайти нову адресу Gaia...",
    "tage": "днів",
    "time_unknown": "Час невідомий",
    "transmission_mode": "Режим передачі",
    "trust_age": "Вік довіри",
    "trust_passport_title": "Паспорт довіри",
    "unbestaetigt": "Непідтверджено",
    "unknown_sender": "Невідомий",
    "unlock_btn": "Розблокувати",
    "unlock_btn_profile": "Розблокувати",
    "unlock_desc": "Ваш файл закритого ключа зберігається в зашифрованому вигляді. Введіть свій пароль, щоб завантажити криптографічні ключі лише в пам’ять.",
    "unlock_logout": "Вийдіть із системи та закрийте локальні ключі",
    "unlock_title": "Розблокувати ідентифікатор",
    "untrusted": "Не заслуговує довіри",
    "update_password": "Оновити пароль",
    "upload_avatar_btn": "Завантажити зображення (дезінфіковане)",
    "vault_btn_encrypt": "Зашифрувати запис",
    "vault_btn_lock": "Сейф на замок",
    "vault_btn_unlock": "Розблокувати сейф",
    "vault_copied_success": "Скопійовано в буфер обміну",
    "vault_decrypted_content": "Розшифрований вміст",
    "vault_desc": "Локальне зашифроване сховище для резервних копій для відновлення, ідентифікаційних нотаток, доступу до сервера, екстрених контактів, юридичних приміток, подій безпеки та особистих журналів.",
    "vault_empty": "Захищених записів ще не збережено.",
    "vault_locked_pane_notice": "Сейф замкнений. Будь ласка, розблокуйте праворуч.",
    "vault_new_record": "Новий безпечний запис",
    "vault_pwd_placeholder": "Введіть пароль сховища...",
    "vault_record_body": "Запис вмісту",
    "vault_record_body_placeholder": "Введіть зашифрований вміст запису...",
    "vault_record_category": "категорія",
    "vault_record_title": "Назва запису",
    "vault_record_title_placeholder": "Назва захищеного запису",
    "vault_title": "Захищені записи GaiaVault",
    "verify_new_fingerprint_hint": "Перш ніж прийняти ключ, перевірте новий відбиток пальця.",
    "vertrauenswuerdig": "Заслуговує довіри",
    "vision_gaia_technology": "Технологія VisionGaia",
    "von": "Від",
    "warnung": "УВАГА",
    "wizard_address": "адресу",
    "wizard_back": "Назад",
    "wizard_check1": "Я безпечно зберіг своє насіння.",
    "wizard_custom_domain": "Використовуйте власний домен",
    "wizard_desc1": "GaiaCOM не зберігає закриті ключі на стороні сервера. Без Mnemonic Seed ніхто не зможе відновити втрачені повідомлення.",
    "wizard_desc2": "Ваша адреса визначає об'єднаний вузол, через який маршрутизуються зашифровані конверти.",
    "wizard_fallback": "Резервні вузли",
    "wizard_finish": "Повне налаштування",
    "wizard_next": "Далі",
    "wizard_server_domain": "Домен вузла сервера",
    "wizard_step1": "1. Резервне насіння",
    "wizard_step2": "2. Адреса та сервер",
    "wizard_title1": "Резервне копіювання ключа відновлення",
    "wizard_title2": "Виберіть адресу GaiaCOM",
    "write_message_placeholder": "Напишіть безпечне повідомлення...",
    "you": "Ви",
    "zero_knowledge": "Нуль знань",
    "zero_knowledge_encryption": "Шифрування з нульовим знанням",
    "Chat fuer alle geleert": "Чат порожній для всіх учасників.",
    "Chat geleert": "Чат очищено для вашої локальної папки \"Вхідні\".",
    "Nachricht fuer alle geloescht": "Повідомлення видалено для всіх учасників.",
    "Nachricht geloescht": "Повідомлення чату було видалено локально з вашої папки \"Вхідні\".",
    "anpinnen": "Pin",
    "chat_loeschen": "Видалити чат",
    "confirm_delete_chat_desc": "Ви впевнені, що хочете видалити та приховати чат?",
    "confirm_leave_group_desc": "Ви дійсно хочете залишити цю групу?",
    "entpinnen": "Відкріпити",
    "group_deleted": "Групу успішно видалено.",
    "group_left": "Успішно покинути групу.",
    "gruppe_loeschen": "Видалити групу",
    "loeschen": "Видалити",
    "no_active_chats": "Немає активних чатів. Знайдіть контакти вище, щоб розпочати чат.",
    "pinned": "Закріплено",
    "wizard_check_credentials": "Я відповідаю за безпеку своїх даних доступу.",
    "wizard_check_is_beta": "Я розумію, що GaiaCom є бета-версією програмного забезпечення.",
    "wizard_check_no_illegal": "Я не використовуватиму GaiaCom у протиправних цілях.",
    "wizard_check_no_uptime": "Я розумію, що немає гарантії наявності.",
    "wizard_check_smtp_security": "Я розумію, що повідомлення SMTP не забезпечують повну безпеку GaiaCom.",
    "wizard_check_terms_read": "Я прочитав бета-версію Умов використання.",
    "wizard_step_terms": "Умови використання",
    "wizard_terms_text": "Умови використання та бета-тестування GaiaCom (бета-фаза)\n\nПостачальник: VisionGaiaTechnology (надалі «Постачальник»)\nСтатус: публічна фаза бета-тестування\nТермін дії: з 21 червня 2026 року\n\n⚠️ НАЙВАЖЛИВІШЕ ПРИМІТКА ПОПЕРЕДНІЙ (БУДЬ ЛАСКА, ПРОЧИТАЙТЕ УВАЖНО)\nGaiaCom знаходиться на етапі публічного бета-тестування. Незважаючи на широкі заходи безпеки, не можна гарантувати відсутність помилок, постійну доступність або абсолютну безпеку програмного забезпечення та базової інфраструктури. Використовуйте на свій страх і ризик. Користувачі несуть відповідальність за безпечне зберігання своїх даних доступу (особливо ключів для GaiaVault) і за дотримання чинного законодавства.\n\n1. Предмет і мета етапу бета-тестування\n1.1. Мета надання: GaiaCom — це новий сервіс електронної пошти та чату, заснований на постквантовій криптографії (PQC). Положення під час бета-фази призначене виключно для технічного тестування, моделювання навантаження, пошуку програмних помилок (багів) і оптимізації зручності для користувача.\n1.2. Бета-статус: користувач усвідомлює, що запропоноване програмне забезпечення є попередньою версією (бета-версія програмного забезпечення). Це ще не повністю технічно розроблено, не відповідає стандартам кінцевого комерційного продукту та може спричинити помилки, втрату даних, затримки передачі або збої системи.\n1.3. Відсутність права на продовження: Постачальник має право в будь-який час повністю або частково припинити надання послуги, змінити або обмежити функції або видалити їх тимчасово або остаточно без пояснення причин.\n\n2. Наявність і відмова від гарантії\n2.1. Немає гарантії доступності: GaiCom надається без жодних гарантій доступності чи безвідмовної роботи. Немає права на безперебійну доступність послуги.\n2.2. Виняток гарантії: програмне забезпечення надається в поточному стані («як є») і залежить від наявності. У межах, дозволених законодавством, будь-які гарантійні претензії щодо матеріальних і юридичних дефектів програмного забезпечення виключаються. Зокрема, немає жодної гарантії, що програмне забезпечення без помилок, шкідливих програм або підходить для певної мети.\n\n3. Управління ризиками та зобов'язання користувачів\n3.1. Заборона зберігання критично важливих даних: Користувач зобов’язується не зберігати та не передавати виключно через GaiaCom будь-які критично важливі для бізнесу, життєво важливі, операційно необхідні або юридично особливо конфіденційні дані (наприклад, файли пацієнтів, дуже конфіденційні фінансові дані чи офіційно регульовані секрети). Послугу не можна використовувати для інфраструктури, де непередбачені збої можуть призвести до травм, пошкодження майна або значних фінансових втрат.\n3.2. Самостійне резервне копіювання: користувач несе відповідальність за резервне копіювання всіх даних, отриманих або надісланих через GaiaCom, які йому потрібні в довгостроковій перспективі, у власних незалежних системах (резервні копії). Провайдер не гарантує постійного зберігання або відновлення даних на своїх серверах.\n\n4. Криптографічні функції та GaiaVault\n4.1. Постквантова криптографія (PQC): GaiaCom реалізує найсучасніші, орієнтовані на майбутнє процеси шифрування, які розроблені, щоб протистояти атакам квантових комп’ютерів майбутнього. Однак користувач усвідомлює, що це динамічна та нова наукова сфера. Абсолютна, незаперечна безпека не може бути гарантована на основі поточного стану науки і техніки. Такі терміни, як «на 100% безпечний», «незламний» або «військовий захист» прямо не гарантуються.\n4.2. Відсутність гарантії відновлення (GaiaVault): GaiaCom покладається на послідовну концепцію безпеки без знань. Шифрування та дані доступу залишаються виключно під контролем користувача (захищено через GaiaVault).\nВАЖЛИВО: якщо користувач втратить свої паролі, парольні фрази, приватні ключі або вихідні коди відновлення, постачальник не матиме технічної можливості відновити або скинути ці дані. Втрата цих даних доступу неминуче призводить до безповоротної втрати доступу до облікового запису користувача та всіх зашифрованих у ньому даних.\n4.3. Ще не повністю перевірено: програмне забезпечення постійно піддається внутрішнім перевіркам безпеки, але на момент цієї бета-фази воно ще не пройшло остаточний, комплексний зовнішній аудит безпеки незалежними органами тестування.\n\n5. Інтерфейси, застарілі протоколи та об'єднання\n5.1. Примітка SMTP Bridge: GaiaCom пропонує можливість спілкуватися через класичні протоколи електронної пошти (наприклад, SMTP). Користувач усвідомлює, що повідомлення, які залишають власну зону безпеки GaiaCom (наприклад, надсилаються на звичайну адресу @gmail.com або @gmx.de), транспортуються через незашифровані або сторонні сервери. Наскрізні гарантії безпеки GaiaCom застосовуються лише обмежено або взагалі не застосовуються до таких вихідних або зовнішніх вхідних застарілих повідомлень.\n5.2. Примітка федерації: якщо GaiaCom працює в об’єднаній мережі, повідомлення та дані можуть проходити через сторонні сервери. Хоча вміст повідомлень залишається захищеним наскрізним шифруванням, метадані (такі як час надсилання, IP-адреси залучених серверів і адреси одержувачів) можуть бути технічно видимими для операторів цих об’єднаних серверів. Постачальник не має впливу на практику захисту даних сторонніх операторів серверів у об’єднаній мережі.\n\n6. Прийнятне використання та заборонена діяльність\nКористувач зобов'язується не використовувати сервіс неналежним чином або в незаконних цілях. Зокрема, заборонено:\n- Розповсюдження, надсилання або розміщення вірусів, зловмисного програмного забезпечення, фішингового вмісту чи іншого шкідливого програмного забезпечення.\n- Використання Сервісу для проведення атак на відмову в обслуговуванні (DDoS) або небажаної масової розсилки (спам).\n- Зловживання системою для здійснення шахрайства.\n- Розповсюдження або обмін незаконним контентом, зокрема зображенням сексуального насильства над дітьми (CSAM), терористичною пропагандою, закликами до насильства чи іншим вмістом кримінального значення.\n\n7. Система звітності про зловживання\n7.1. Повідомлення про образливу поведінку: користувачі мають можливість повідомити про образливе спілкування або незаконну діяльність через інтегровану систему порушення.\n7.2. Обробка звітів: щоб забезпечити захист від зловживання, вхідні звіти можна технічно аналізувати (зберігаючи конфіденційність і обмеження шифрування). Це може призвести до тимчасового або постійного призупинення облікових записів користувачів або IP-адрес у разі доведених порушень цих умов використання.\n\n8. Обмеження відповідальності\n8.1. Стандарт відповідальності: бета-версія програмного забезпечення надається безкоштовно. Згідно з правовими нормами щодо пожертвувань або позик, постачальник несе відповідальність лише за намір (навмисне пошкодження) та грубу недбалість.\n8.2. Виняток відповідальності за втрату даних: відповідальність за втрату даних виключається, якщо втрата не була спричинена навмисно або через грубу недбалість постачальника, а користувач виконав свої зобов’язання щодо зменшення збитків шляхом регулярного резервного копіювання (за межами GaiaCom).\n8.3. Юридичні обмеження. Наведені вище обмеження відповідальності не застосовуються до шкоди життю, тілу чи здоров’ю або до відповідальності відповідно до Закону про відповідальність за продукцію.\n\n9. Відкритий код\nДеякі компоненти, бібліотеки або клієнтські програми GaiaCom можуть бути ліцензовані за ліцензіями з відкритим кодом (наприклад, GPL, MIT, Apache). Ці умови використання не впливають на відповідні умови ліцензії цих компонентів, і їх можна переглянути у відповідних сховищах вихідного коду.\n\n10. Експортний контроль і відповідність\nКористувач усвідомлює, що криптографічне програмне забезпечення може підлягати суворому експортному контролю та юридичним обмеженням. Користувач несе відповідальність за те, щоб використання GaiaCom не порушувало законів, імпортних/експортних обмежень або правил криптографії відповідної країни проживання.\n\n11. Повідомлення про захист даних (коротка версія для бета-версії)\n11.1. Мінімальний збір даних: у рамках бета-фази постачальник збирає лише дані, які абсолютно необхідні для технічної роботи, усунення несправностей і подальшого розвитку (наприклад, файли журналу сервера для діагностики помилок).\n11.2. Відсутність уявлення про вміст: завдяки постійному нульовому шифруванню та шифруванню E2E постачальник ніколи не матиме доступу до вмісту ваших чатів, електронних листів або ключів, що зберігаються в GaiaVault.\n11.3. Детальна декларація про захист даних: докладні положення про захист даних наведено окремо, і користувач також повинен їх врахувати перед реєстрацією.\n\n12. Прикінцеві положення\n12.1. Застосовне право: Застосовується законодавство Федеративної Республіки Німеччина, за винятком Конвенції ООН про договори міжнародної купівлі-продажу товарів.\n12.2. Можливі зміни: оскільки GaiaCom знаходиться в стадії активного розвитку, провайдер залишає за собою право змінювати ці умови в будь-який час з урахуванням майбутнього. Поточна версія доступна в додатку.",
    "wizard_terms_title": "Умови використання та бета-тестування GaiaCom (бета-фаза)",
    "node_operator": "Оператор вузла",
    "search_channels": "Пошук каналів...",
    "senior_reviewer": "Старший рецензент",
    "trusted_reviewer": "Довірений рецензент",
    "active_frequencies": "Активні частоти",
    "connected_rooms": "ПОВ’ЯЗАНІ ПРОСТОРИ",
    "dashboard": "Приладова панель",
    "empty_chats": "Немає активних чатів.",
    "empty_messages": "Немає нових повідомлень.",
    "encrypted": "Зашифровано",
    "gaiacom_uplink": "GAIACOM UPLINK",
    "install_app": "Встановити додаток",
    "install_app_desc": "Для швидкого запуску та режиму офлайн",
    "kommandozentrale_alpha": "Командний центр АЛЬФА",
    "network_online": "МЕРЕЖА: ОНЛАЙН",
    "new_room": "Новий простір",
    "no_frequencies_active": "Немає активних частот. Створіть нову кімнату, щоб почати спілкування.",
    "no_id": "Без посвідчення особи",
    "open_chats": "Відкрити чати",
    "open_inbox": "Відкрити вхідні",
    "primary_identity": "ПЕРВИННА ІДЕНТИЧНІСТЬ",
    "recent_chats": "Нові чати",
    "recent_messages": "Останні новини",
    "session_encrypted": "Сеанс зашифровано: {name}",
    "session_secure": "СТАТУС: БЕЗПЕКА",
    "system_verlassen": "Система виходу",
    "write_message": "Написати повідомлення",
    "onboarding_step_profile": "Профіль",
    "onboarding_step_security": "Захист",
    "onboarding_step_backup": "Резерв",
    "onboarding_step_launch": "Запуск",
    "onboarding_loading_gaia_id": "Завантаження Gaia-ID",
    "onboarding_setup_kicker": "Початкове налаштування GaiaCom",
    "onboarding_profile_title": "Зробіть GaiaCom своїм простором.",
    "onboarding_profile_desc": "Ваше відображуване ім'я та аватар залишаються під локальним контролем і можуть бути змінені у профілі в будь-який час.",
    "onboarding_security_title": "Що GaiaCom захищає для вас прямо зараз.",
    "onboarding_security_desc": "GaiaCom розділяє особистість, ключі, повідомлення та стан мережі. Тут ви бачите лише коротку версію для користувача.",
    "onboarding_backup_title": "Резервне копіювання — це ваш справжній аварійний вихід.",
    "onboarding_backup_desc": "Без даних відновлення ніхто не зможе врятувати вашу особистість. Саме в цьому полягає суть справжньої наскрізної безпеки.",
    "onboarding_launch_title": "Готово. Що ви хочете зробити спочатку?",
    "onboarding_launch_desc": "Ви можете почати прямо зараз або закінчити тур і продовжити роботу на панелі керування.",
    "onboarding_display_name": "Відображуване ім'я",
    "onboarding_display_name_placeholder": "Як GaiaCom має відображати вас?",
    "onboarding_select_avatar": "Вибрати аватар",
    "onboarding_sec_identity_title": "Ідентичність",
    "onboarding_sec_identity_desc": "Ваш Gaia-ID — це ваш мережевий якір. Контакти можуть виявляти зміну ключів.",
    "onboarding_sec_messages_title": "Повідомлення",
    "onboarding_sec_messages_desc": "Вміст розшифровується локально. Відредаговані повідомлення отримують нові підписи.",
    "onboarding_sec_network_title": "Мережа",
    "onboarding_sec_network_desc": "Центр безпеки та Центр скарг показують ризики без глобального бекдору.",
    "onboarding_sec_transparency_title": "Прозорість",
    "onboarding_sec_transparency_desc": "Записує події безпеки в протокол, щоб попередження залишалися відстежуваними.",
    "onboarding_backup_notice_title": "Важливо для звичайних користувачів",
    "onboarding_backup_notice_desc": "Зберігайте дані відновлення окремо від цього пристрою. У разі втрати пароля та резервної копії GaiaCom навмисно залишається заблокованим.",
    "onboarding_backup_consent": "Я знаю, що моя резервна копія є вирішальною для відновлення та зміни пристрою.",
    "onboarding_inbox_title": "Вхідні",
    "onboarding_inbox_desc": "Читати листи та написати своє перше повідомлення.",
    "onboarding_contacts_title": "Контакти",
    "onboarding_contacts_desc": "Перевірити перший контакт або почати чат.",
    "onboarding_channels_title": "Канали",
    "onboarding_channels_desc": "Відкривати публічні частоти.",
    "onboarding_security_title_card": "Центр безпеки",
    "onboarding_security_desc_card": "Переглянути статус GaiaShield.",
    "onboarding_later": "Пізніше",
    "onboarding_back": "Назад",
    "onboarding_continue": "Продовжити",
    "onboarding_complete_setup": "Завершити налаштування",
    "auth_legal_consent": "Я прочитав та погоджуюся з політикою конфіденційності та умовами використання.",
    "auth_show_terms": "Показати умови використання",
    "auth_recovery_mode": "Режим відновлення",
    "auth_recovery_import_title": "Імпорт файлу відновлення",
    "auth_recovery_import_desc": "Відновіть свої ключі GaiaCom із захищеного паролем файлу резервної копії. Після цього мнемоніка та ім'я користувача будуть заповнені автоматично.",
    "auth_recovery_file_pwd_placeholder": "Пароль файлу відновлення",
    "auth_recovery_local_pwd_placeholder": "Новий пароль локального розблокування мінімум 12 символів",
    "auth_recovery_importing": "Імпортування...",
    "auth_recovery_decrypt": "Розшифрувати відновлення",
    "auth_back_to_login": "Назад до входу",
    "auth_terms_title": "Умови використання GaiaCom Beta",
    "auth_terms_close": "Закрити",
    "auth_cookie_title": "GaiaCOM зберігає свій суверенітет.",
    "auth_cookie_desc": "Ми використовуємо лише технічно необхідне локальне сховище для мови, сесії та безпеки. Жодного відстеження, рекламних файлів cookie чи профілів третіх сторін.",
    "auth_cookie_accept": "Зрозуміло",
    "sc_explainer_title": "Що тут насправді захищено?",
    "sc_explainer_desc": "GaiaShield — це захисний шар між вашим обліковим записом, повідомленнями та мережею. Він вирішує не стосовно вмісту, а стосовно технічних ризиків: маніпуляції, спроби повторення, несанкціонований доступ, підозрілі шаблони входу та небезпечні переходи шлюзів.",
    "sc_explainer_identity_desc": "Перевіряє аномалії входу, ризики сесії та доступ до інших ідентичностей.",
    "sc_explainer_messages_desc": "Виявляє шаблони повторень, зманіпульовані конверти та відсутність ознак цілісності.",
    "sc_explainer_network_desc": "Позначає ризики федерації, обмеження швидкості та SMTP до того, як довіра буде неправильно відображена.",
    "sc_open_security_warnings": "Відкриті попередження безпеки",
    "sc_opt_all": "Всі",
    "sc_opt_low": "Низький",
    "sc_opt_medium": "Середній",
    "sc_opt_high": "Високий",
    "sc_opt_critical": "Критичний",
    "sc_opt_failed_login": "Недавній невдалий вхід",
    "sc_opt_auth_attack": "Атака авторизації",
    "sc_opt_rate_limit": "Обмеження швидкості",
    "sc_opt_policy_violation": "Повідомлення про політики",
    "sc_opt_message_replay": "Повторення повідомлення",
    "sc_node_security_data_unavailable": "Дані безпеки вузла недоступні",
    "sc_total_events": "Всього подій",
    "sc_login_attacks": "Атаки на вхід",
    "sc_rate_limits_active": "Активні ліміти швидкості",
    "sc_smtp_shield_hits": "Спрацьовування SMTP Shield",
    "sc_top_event_categories": "Топ категорій подій",
    "sc_no_entries": "Немає записів.",
    "sc_node_audit_log": "Журнал аудиту вузла (останні)",
    "sc_no_node_events": "Немає подій вузла.",
    "archiv": "Архів",
    "entwuerfe": "Чернетки",
    "markiert": "Позначені",
    "wichtig": "Важливі",
    "snoozed": "Відкладені",
    "papierkorb": "Кошик",
    "spam": "Спам",
    "cancel": "Скасувати",
    "error": "Помилка",
    "success": "Успіх",
    "kopieren": "Копіювати",
    "block_contact": "Блокувати контакт",
    "unblock_contact": "Розблокувати контакт",
    "report_contact": "Поскаржитися на контакт",
    "check_fingerprint": "Перевірити відбиток",
    "export_encrypted": "Експорт (Зашифровано)",
    "export_gaiaproof": "Експорт (GaiaProof)",
    "export_password_prompt": "Введіть пароль для шифрування експорту чату:",
    "export_success": "Чат успішно експортовано та зашифровано.",
    "export_failed": "Помилка експорту: ",
    "gaiaproof_export_success": "Пакет GaiaProof успішно експортовано.",
    "gaiaproof_export_failed": "Помилка експорту GaiaProof: ",
    "export_gaiaproof_confirm": "Бажаєте завантажити пакет GaiaProof з усіма підписами та підтвердженнями доставки сервера? Це може зайняти деякий час.",
    "group_settings_is_private": "Приватна кімната (без публічного пошуку, лише за запитами на вступ)",
    "group_settings_read_only": "Режим лише для читання (тільки власник та адміни можуть надсилати повідомлення)",
    "group_settings_slow_mode": "Повільний режим (затримка відправки)",
    "gsn_title": "Соціальна стрічка GSN",
    "gsn_node_feed": "Стрічка вузла",
    "gsn_following_feed": "Підписки",
    "gsn_feed_empty": "Дописів не знайдено.",
    "gsn_composer_placeholder": "Що нового у федерації?",
    "gsn_post_btn": "Поділитися",
    "gsn_profile": "Профіль користувача",
    "gsn_followers": "Підписники",
    "gsn_following": "Підписки",
    "gsn_bio": "Опис / Біо:",
    "gsn_bio_label": "Опис / Біо",
    "gsn_display_name": "Відображуване ім'я",
    "gsn_edit_profile": "Редагувати профіль",
    "gsn_save_profile": "Зберегти",
    "gsn_add_image": "Додати зображення (Зашифровано)",
    "gsn_add_emoji": "Вставити емодзі",
    "gsn_avatar_emoji": "Аватар (Емодзі)",
    "gsn_follow": "Стежити",
    "gsn_unfollow": "Скасувати підписку",
    "gsn_repost": "Поділитися / Репост",
    "gsn_post_created": "Допис успішно опубліковано.",
    "gsn_image_uploaded": "Зобрження зашифровано та завантажено.",
    "gsn_upload_failed": "Помилка завантаження зображення: ",
    "gsn_comment_placeholder": "Напишіть коментар...",
    "gsn_delete_confirm_title": "Вилучити допис?",
    "gsn_delete_confirm_desc": "Ви впевнені, що хочете назавжди вилучити цей допис?",
    "gsn_delete_comment_confirm_title": "Вилучити коментар?",
    "gsn_delete_comment_confirm_desc": "Ви впевнені, що хочете назавжди вилучити цей коментар?",
    "gsn_report": "Поскаржитися",
    "gsn_report_title": "Повідомити про порушення",
    "gsn_report_category": "Категорія",
    "gsn_report_spam": "Спам / Реклама",
    "gsn_report_harassment": "Цькування / Мова ворожнечі",
    "gsn_report_abuse": "Зловживання",
    "gsn_report_illegal": "Незаконний вміст",
    "gsn_report_severity": "Серйозність",
    "gsn_report_low": "Низька",
    "gsn_report_medium": "Середня",
    "gsn_report_high": "Висока",
    "gsn_report_comment": "Додатковий коментар",
    "gsn_report_submit": "Поскаржитися",
    "gsn_report_submitted": "Скарга надіслана модераторам.",
    "gsn_report_post": "Повідомити про допис",
    "report_group": "Повідомити про групу",
    "report_group_reason_prompt": "Введіть причину скарги (необов'язково):",
    "report_reason_prompt": "Введіть причину скарги (необов'язково):",
    "report_failed": "Помилка скарги: ",
    "report_success": "Контакт успішно повідомлено.",
    "room_read_only_placeholder": "Тільки власник та адміни можуть писати",
    "read_only_active": "Режим лише для читання",
    "slow_mode_active": "Повільний режим активний",
    "kommandozentrale": "Командний центр",
    "kontakt_blockiert": "Контакт заблоковано",
    "kontakt_freigegeben": "Контакт розблоковано",
    "mailbox_settings_title": "Налаштування скриньки",
    "mailbox_settings_desc": "Керування підписом, мовою, фільтрами пошти.",
    "mic_access_denied": "Доступ до мікрофона заборонено: ",
    "no_frequencies_active_desc": "Створіть нову кімнату, щоб розпочати спілкування.",
    "key_changed_warning_title": "ПОПЕРЕДЖЕННЯ ПРО БЕЗПЕКУ:",
    "key_changed_warning_desc": "Ключ ідентифікації цього відправника було оновлено або він відрізняється від раніше відомого. Підтвердьте відбиток іншим безпечним каналом зв'язку.",
    "sc_col_category": "Категорія",
    "search_members": "Пошук учасників...",
    "tab_general": "Загальні",
    "tab_members": "Учасники",
    "tab_requests": "Запити",
    "tab_invites": "Запрошення",
    "tab_logs": "Логи",
    "auth_why_gaiacom": "Чому GaiaCOM?",
    "auth_why_gaiacom_desc": "Безпечна децентралізована альтернатива для вашого конфіденційного спілкування.",
    "auth_self_managed_id": "Самокерований ID",
    "auth_self_managed_id_desc": "Миттєво створюйте безпечні криптографічні ідентифікатори без вказівки пошти чи телефону.",
    "auth_gaiadrop_secure_exchange": "Безпечний обмін без акаунта",
    "auth_gaiadrop_benefit_e2ee": "Наскрізне шифрування",
    "auth_gaiadrop_benefit_no_login": "Вхід не потрібен",
    "auth_gaiadrop_benefit_inbox": "Пряма доставка до поштової скриньки одержувача",
    "auth_terms_of_use": "Умови використання",
    "auth_terms_of_use_show": "Показати умови використання",
    "auth_consent_privacy_terms": "Я прочитав та погоджуюся з політикою конфіденційності та умовами використання.",
    "auth_recovery_import_file": "Імпортувати файл відновлення",
    "auth_recovery_password": "Пароль файлу відновлення",
    "auth_recovery_local_password": "Новий локальний пароль розблокування щонайменше 12 символів",
    "auth_recovery_decrypting": "Розшифрування відновлення...",
    "auth_recovery_back": "Назад до входу",
    "auth_cookie_sovereign": "GaiaCOM залишається суверенним.",
    "auth_cookie_sovereign_desc": "Ми використовуємо лише технічно необхідні функції локального сховища для мови, сеансу та безпеки. Без відстеження, без рекламних файлів cookie, без профілів третіх осіб.",
    "auth_cookie_sovereign_accept": "Зрозуміло",
    "unlock_keyboard_toggle": "⌨️ Використовувати клавіатуру",
    "unlock_keypad_toggle": "🔢 Використовувати PIN-пад",
    "unlock_status_denied": "ДОСТУП ЗАБОРОНЕНО / ПОВТОРІТЬ",
    "unlock_status_decrypting": "РОЗШИФРУВАННЯ СХОВИЩА...",
    "unlock_status_secured": "СХОВИЩЕ ЗАХИЩЕНО / ЗАБЛОКОВАНО",
    "auth_landing_nav_legal": "Юридичні документи",
    "auth_landing_nav_beta": "Бета-тест",
    "auth_landing_card1_title": "Постквантова криптографія (ML-KEM)",
    "auth_landing_card2_title": "100% Децентралізація",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Захист метаданих",
    "auth_landing_card5_title": "Самокерований ID",
    "auth_landing_hybrid_title": "Сучасна криптографія плюс захист від загроз завтрашнього дня.",
    "auth_landing_hybrid_desc": "GaiaCom поєднує перевірений часом класичний обмін ключами з постквантовим інкапсулюванням. Захист в глибину.",
    "auth_landing_x25519_desc": "Швидкий та перевірений обмін ключами на еліптичних кривих для сучасних пристроїв.",
    "auth_landing_mlkem_desc": "Постквантове інкапсулювання для довготривалого захисту від дешифрування в майбутньому.",
    "auth_landing_cycle_title": "Сервер нічого не бачить. Мережа передає лише білий шум.",
    "auth_landing_step1_title": "Локальне шифрування",
    "auth_landing_step1_desc": "Повідомлення шифрується на пристрої відправника до того, як потрапить в мережу або на сервер.",
    "auth_landing_step2_title": "Передача у вигляді блоба",
    "auth_landing_step2_desc": "Пакет передається як криптографічний шум через розподілені вузли або рівні зберігання.",
    "auth_landing_step3_title": "Розподілене зберігання",
    "auth_landing_step3_desc": "Немає центральної поштової скриньки. Дані фрагментовані, розподілені і повністю зашифровані.",
    "auth_landing_step4_title": "Локальне дешифрування",
    "auth_landing_step4_desc": "Тільки приватний ключ одержувача може перетворити отриманий блоб назад у текст.",
    "auth_landing_trinity_title": "Один протокол. Три рівні інфраструктури.",
    "auth_landing_enterprise_desc": "Для корпорацій, юридичних фірм, бізнесу та приватного банкінгу. Закриті комунікації з адміністративним контролем.",
    "auth_landing_enterprise_list1": "Внутрішній суверенітет та управління користувачами",
    "auth_landing_enterprise_list2": "Власний сервер (self-hosted) або керований суверенний кластер",
    "auth_landing_enterprise_list3": "Угода SLA, техпідтримка та преміум-модулі",
    "auth_landing_network_desc": "Відкрита мережа для цифрової приватності. Без продажу даних, інфраструктура для вільного захищеного зв'язку.",
    "auth_landing_network_list1": "Клієнтський додаток з відкритим вихідним кодом",
    "auth_landing_network_list2": "Федеративні вузли (ноди)",
    "auth_landing_network_list3": "Відсутність центрального ключа розшифровки",
    "auth_landing_defend_desc": "Спеціалізована інфраструктура для державних органів та ізольованих сегментів зв'язку.",
    "auth_landing_defend_list1": "Розгортання в ізольованих фізичних мережах (air-gapped)",
    "auth_landing_defend_list2": "Можливість брендування та аудит вихідного коду",
    "auth_landing_defend_list3": "Національний цифровий суверенітет кластера",
    "auth_landing_gov_title": "Відкритий протокол. Комерційна реалізація. Розділення прав.",
    "auth_landing_gov_desc": "GaiaCom розділяє публічний протокол, відкриті клієнти та комерційні рішення. Довіра будується на відкритості.",
    "auth_landing_price1_desc": "Плата за захист від ботів при розповсюдженні через магазини додатків.",
    "auth_landing_price2_desc": "Безкоштовно для користувачів, які збирають додаток з вихідного коду самостійно.",
    "auth_landing_price3_desc": "Для середнього бізнесу, юридичних фірм та конфіденційних команд.",
    "auth_landing_price4_desc": "Для великих корпорацій, відмовостійких кластерів, LDAP та рут-досту.",
    "auth_landing_license1_desc": "Максимальна прозорість коду для аудиту та спільноти.",
    "auth_landing_license2_desc": "Захист copyleft від привласнення та закриття коду хмарними сервісами.",
    "auth_landing_license3_desc": "LDAP, рут-доступ, аудит безпеки, SLA та бізнес-логіка.",
    "auth_landing_final_title": "Комунікація за моделлю нульової довіри.",
    "auth_landing_final_desc": "GaiaCom не просто замінює email. Він змушує замислитися, чому конфіденційні дані все ще лежать на серверах, заснованих на технологіях 40-річної давнини.",
    "auth_landing_final_note": "Примітка: Сторінка описує концепцію та плани розвитку. Заявлені властивості безпеки мають бути підтверджені аудитом перед запуском."




  };

export default uk;